<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- JSON Content Display -->
  <div class="container-fluid">
    @if (showJsonLoader) {
<div class="viewBatchLoader">
      <i class="fa fa-spinner fa-spin fa-2x gt-refresh"></i>
    </div>
}
    
    @if (!showJsonLoader) {
<div>
      <div class="JsonContainer">
        <div class="json-header">
          <span class="new new_block">Request Input JSON</span>
          @if (fileToDownload) {
<button class="download-button" 
                  type="button"
                  (click)="downloadFile()"
                 >
            Download File
          </button>
}
        </div>
        <pre class="old_new_view" [innerHTML]="monitoringData"></pre>
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="button-cancel"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
